export const TRANSLATIONS = {
  OTP_HEADER: 'Invalid OTP',
  LIMIT_EXCEEDED: 'You have exceeded the limit.',
  TRY_AGAIN: 'Try again after 24 hours.',
  OR: 'or',
  CONTACT_OPINARY: 'Contact Opinary support',
}
